import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import ActionModalBar from '../../../../../../../components_v1/Actions/ActionModalBar';
import InputText from '../../../../../../../components_v1/Forms/InputText';
import InputSelect from '../../../../../../../components_v1/Forms/InputSelect';
import SimpleModal from '../../../../../../../components_v1/Structure/Modals/SimpleModal';
import DisplayText from '../../../../../../../components_v1/Texts/DisplayText';
import { isFormValid, onGetFormData, onInitForm, onSetErrorsToForm } from '../../../../../../../shared/utility';
import {formData} from './contactinfodata/data'
import {contentData} from './contactinfodata/content'

const useStyles = makeStyles(theme => ({
    form:{
        paddingTop:32,
        paddingBottom:32
    }
}))

const ContactInfoModal = props => {

    const classes = useStyles()
    const { open, sending, onClose, catalogs, origin_data, history, language } = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const content = contentData[language]

    useEffect(() => {
        if (!open) {
            let _form = JSON.parse(JSON.stringify(formData))
            _form = onInitForm(_form, origin_data, content.form)
            setForm({..._form})            
            setError('')
            setLoading(false)
        }
    }, [open, origin_data])

    const onChange = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        setForm(temp)
    }

    const onSubmit = async () => {
        const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            return
        }
        
        //Extract data
        let data2send = onGetFormData(form)
        //Send data
        setLoading(true)
        props.onSubmit(data2send)
        setLoading(false)
    }

    return ( 
        <SimpleModal open={open} onClose={onClose} maxWidth='md'>
            <div>
                <DisplayText variant='h6' color='primary' style={{ fontWeight: 500 }}>{content.title}</DisplayText>
                <div className={classes.form}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <InputText data={form.phone_number} onChange={onChange}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText data={form.work_email} onChange={onChange}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText data={form.personal_email} onChange={onChange}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText data={form.gmail} onChange={onChange}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText data={form.dropbox} onChange={onChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            <ActionModalBar btnLabel='Guardar' loading={sending} error={error} onSubmit={onSubmit}/>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </SimpleModal>
     );
}
 
export default ContactInfoModal;